import axios from 'axios';

// TODO: 接口地址
const request = axios.create({
  baseURL: 'https://aitoken.fans/',
  timeout: 30000,
});

export default request;
